export default __webpack_public_path__ + "static/media/step_G_2@2x.e54a3551.png";